enum VersionStatus {
    NA = "N/A",
    PendingApproval = "Pending Approval",
    Approved = "Approved",
    Rejected = "Rejected"
}

export default VersionStatus;
